import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

export interface ModelTemplateSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  sx?: object;
}

/** Campo de pesquisa de modelos com ícone de lupa. */
const ModelTemplateSearchField: React.FC<ModelTemplateSearchFieldProps> = ({
  value,
  onChange,
  placeholder = 'Pesquisar por título...',
  sx,
}) => (
  <TextField
    fullWidth
    size="small"
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    sx={{ mb: 1.25, ...sx }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon sx={{ color: '#94a3b8', fontSize: 18 }} />
        </InputAdornment>
      ),
    }}
  />
);

export default ModelTemplateSearchField;
